<template>
    <div>
        <div
            style="
        width: 270px;
        float: right;
        height: 410px;
        overflow: hidden;
        background: #ffffff;
        box-shadow: 0px 0px 11px 1px rgba(161, 150, 150, 0.22);
        margin-top:10px;
        margin-right:10px
      "
        >
            <div class="swiper_right_box_top">
                <a-row>
                    <a-col @click="changSwiperRightBox(index)" :span="8" v-for="(item, index) in swiper_right_box" :key="index" style="background: #f6f6f6" :class="swiper_right_box_index == index ? 'swiper_right_box_top_active' : ''">
                        {{ item }}
                    </a-col>
                </a-row>
            </div>
            <div style="width: 100%; height: 80%">
                <div v-if="swiper_right_box_index == 0">
                    <div class="swiper_right_box_top_jylc_title" style="margin-top:20px">
                        科隆化学商城交易流程
                    </div>
                    <div style="overflow: hidden; width: 75%; margin: 13px auto">
                        <div style="float: left" class="tubiao">
                          <div @click="goods_type">
                            <div class="right_box1_img" style="margin-left: 5px; margin-top: 9px">
                                <img src="../assets/index/r_1.png" style="width: 21px; height: 25px" alt="" />
                            </div>
                          </div>
                            <div class="txt200" @click="shop_cart">
                            <div class="right_box1_img" style="margin-left: 5px">
                                <img src="../assets/index/r_2.png" style="width: 18px; height: 24px" alt="" />
                            </div>
                            </div>
                            <div class="txt200" to="/order?id=3" @click="order">
                              <div class="right_box1_img" style="margin-left: 5px">
                                <img src="../assets/index/r_3.png" style="width: 22px; height: 17px" alt="" />
                              </div>
                            </div>

                            <div class="txt200" to="/control_over_invoices"  @click="control_over">
                            <div class="right_box1_img" style="margin-left: 5px;margin-bottom:4px">
                                <img src="../assets/index/r_4.png" style="width: 20px; height: 20px" alt="" />
                            </div>
                            </div>
                        </div>
                        <div style="float: left; margin-top: 5px">
                            <div to="/goods_type">
                                <div class="txt200" style="margin-top: 2px; margin-left: 20px">
                                    <div class="right_box1_txt1">下单购物</div>
                                    <div class="right_box1_txt1" style="margin-top: 5px; font-size: 12px">
                                        商城加入购物车
                                    </div>
                                </div>
                            </div>
                            <div class="txt200" to="/shop_cart">
                                <div style="margin-top: 29px; margin-left: 20px">
                                    <div class="right_box1_txt1">订单结算</div>
                                    <div class="right_box1_txt1" style="margin-top: 5px; font-size: 12px; color: #666">
                                        确认订单并支付货款
                                    </div>
                                </div>
                            </div>
                            <div class="txt200" to="/order?id=3">
                            <div style="margin-top: 29px; margin-left: 20px">
                                <div class="right_box1_txt1">物流发出</div>
                                <div class="right_box1_txt1" style="margin-top: 5px; font-size: 12px; color: #666">
                                    仓库打包发货
                                </div>
                            </div>
                            </div>
                            <div class="txt200" to="/control_over_invoices">
                                <div style="margin-top: 27px; margin-left: 20px">
                                    <div class="right_box1_txt1">开具发票</div>
                                    <div class="right_box1_txt1" style="margin-top: 5px; font-size: 12px; color: #666">
                                        收货后申请发票
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div style="overflow: hidden">
            <a-row>

                  <a-col
                    class="my_order_box"
                    :span="12"
                    style="
                      border: 1px solid #f5f4f4;
                      cursor: pointer;
                      border-top: none;
                    "
                  >
                    <img
                      src="../assets/youhui1.png"
                      style="
                        margin: 10px auto;
                        display: block;
                        width: 26px;
                        height: 26px;
                      "
                      alt=""
                    />
                    <p class="txtx12">满减优惠</p>
                  </a-col>

                <router-link to="/order">
                  <a-col
                    class="my_order_box"
                    :span="12"
                    style="
                      border: 1px solid #f5f4f4;
                      cursor: pointer;
                      border-top: none;
                    "
                  >
                    <img
                      src="../assets/dindan1.png"
                      style="
                        margin: 10px auto;
                        display: block;
                        width: 26px;
                        height: 26px;
                      "
                      alt=""
                    />
                    <p class="txtx12">我的订单</p>
                  </a-col>
                </router-link>
                <router-link to="/credit_y">
                  <a-col
                    class="my_order_box"
                    :span="12"
                    style="
                      border: 1px solid #f5f4f4;
                      cursor: pointer;
                      border-bottom: none;
                    "
                  >
                    <img
                      src="../assets/jifen1.png"
                      style="
                        margin: 10px auto;
                        display: block;
                        width: 26px;
                        height: 26px;
                      "
                      alt=""
                    />
                    <p class="txtx12" style="margin-top: 13px">额度管理</p>
                  </a-col>
                  </router-link>
                  <router-link to="/qualifications">
                  <a-col
                    class="my_order_box"
                    :span="12"
                    style="
                      border: 1px solid #f5f4f4;
                      cursor: pointer;
                      border-bottom: none;
                    "
                  >
                    <img
                      src="../assets/zizhi1.png"
                      style="
                        margin: 10px auto;
                        display: block;
                        width: 26px;
                        height: 26px;
                      "
                      alt=""
                    />
                    <p class="txtx12" style="margin-top: 13px">我的资质</p>
                  </a-col>
                  </router-link>
            </a-row>
          </div> -->
                </div>

                <div v-show="swiper_right_box_index == 1">
                    <div class="title1s">温馨提示：本商城查询不到的产品，或批量采购，请在此询价</div>
                    <div style="overflow: hidden; margin-top: 10px; margin-left: 10px">
                        <span class="swiper_right_box_txt">商品名称/CAS号：</span>
                        <a-input v-model="zhaohuo_obj.goodsName" placeholder="商品名称/CAS号" style="float: left; width: 134px" />
                    </div>
                    <div style="overflow: hidden; margin-top: 10px; margin-left: 10px">
                        <span class="swiper_right_box_txt">采购数量：</span>
                        <a-input v-model="zhaohuo_obj.purchaseQuantity" placeholder="采购数量" style="float: left; width: 113px" />
                        <a-select v-model="zhaohuo_obj.unit" default-value="g" style="width: 58px; float: left; margin-left: 10px">
                            <a-select-option v-for="i in list_unit" :key="i" :value="i">{{ i }}</a-select-option>
                        </a-select>
                    </div>
                    <div style="overflow: hidden; margin-top: 10px; margin-left: 10px">
                        <span class="swiper_right_box_txt">联系电话：</span>
                        <a-input v-model="zhaohuo_obj.userNum" placeholder="联系电话" style="float: left; width: 182px" />
                    </div>
                    <div style="overflow: hidden; margin-top: 10px; margin-left: 10px">
                        <span class="swiper_right_box_txt">公司名/单位：</span>
                        <a-input v-model="zhaohuo_obj.company" placeholder="公司名/单位" style="float: left; width: 164px" />
                    </div>
                    <div style="overflow: hidden; margin-top: 10px; margin-left: 10px">
                        <span class="swiper_right_box_txt">备注：</span>
                        <a-textarea v-model="zhaohuo_obj.remarks" placeholder="备注" style="float: left; width: 210px" />
                    </div>
                    <div class="attachment">
                      <label>
                        <img src="./icon/upicon.png" width="17" height="15" alt="">
                        <span class="dianji">{{ attachment }}</span>
                        <input type="file" hidden @change="uploadAttachment">
                      </label>
                    </div>
                    <div class="bangmangzhaohou btn btn-search" @click="create_findGoods">免费询价</div>
                </div>
                <div v-show="swiper_right_box_index == 2">
                    <div class="title1s">温馨提示：请填写以下信息，我们会有工作人员与您取得联系</div>
                    <div style="overflow: hidden; margin-top: 7px; margin-left: 14px">
                        <span class="swiper_right_box_txt">公司名/单位：</span>
                        <a-input v-model="form_apply.companyName" placeholder="请输入公司/单位信息" style="float: left; width: 158px" class="input1" />
                    </div>
                    <div style="overflow: hidden; margin-top: 7px; margin-left: 14px">
                        <div class="left">公司类型：</div>
                        <a-input v-model="form_apply.companyType" placeholder="请输入" class="input1" />
                    </div>
                    <div style="overflow: hidden; margin-top: 7px; margin-left: 14px">
                        <div class="left">所在省份：</div>
                        <div class="select-region">
                          <a-select style="width: 100%;" v-model="form_apply.district.district1" @change="sheng_Change">
                            <a-select-option :key="index" v-for="(item,index) in list_provicne" :value="item.name">{{ item.name }}</a-select-option>
                          </a-select>
                          <!-- <a-select style="width: 100%;" v-model="form_apply.district.district2" @change="shi_Change">
                            <a-select-option :key="index" v-for="(item,index) in list_city" :value="item.name">{{ item.name }}</a-select-option>
                          </a-select> -->
                        </div>
                        <div class="left" style="margin-top:10px">所在市级：</div>
                        <div class="select-region" style="margin-top:10px">
                          <a-select style="width: 100%;" v-model="form_apply.district.district2" @change="shi_Change">
                            <a-select-option :key="index" v-for="(item,index) in list_city" :value="item.name">{{ item.name }}</a-select-option>
                          </a-select>
                        </div>
                    </div>
                    <div style="overflow: hidden; margin-top: 7px; margin-left: 14px">
                        <div class="left">详细地址：</div>
                        <a-input v-model="form_apply.district.districtDetail" placeholder="请输入" class="input1" />
                    </div>
                    <div style="overflow: hidden; margin-top: 7px; margin-left: 14px">
                        <div class="left">联系人：</div>
                        <a-input v-model="form_apply.contacts" placeholder="请输入" class="input1" />
                    </div>
                    <div style="overflow: hidden; margin-top: 7px; margin-left: 14px">
                        <div class="left">手机号：</div>
                        <a-input v-model="form_apply.contactsTel" placeholder="请输入" class="input1" />
                    </div>
                    <div class="bot btn" @click="submitApply">提交信息</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SwiperRight',
    data() {
        return {
            swiper_right_box: ['交易流程', '我要询价', '购物申请'],
            swiper_right_box_index: 0,
            zhaohuo_obj: {
                company: '',
                goodsName: '',
                purchaseQuantity: '',
                remarks: '',
                attachment: '',
                unit: 'g',
                userId: localStorage.uuid,
                userName: localStorage.username,
                userNum: ''
            },
            form_apply: {
              "companyName": "",
              "companyType": "",
              "contactRemarks": "",
              "contacts": "",
              "contactsTel": "",
              "district": {
                "district1": "",
                "district1Id": 0,
                "district2": "",
                "district2Id": 0,
                "districtDetail": ""
              },
              "remarks": "",
              "userId": ""
            },
            list_provicne: [],
            list_city: [],
            list_unit: ['ton','kg','g','mg','L','ml'],
            attachment: '点此上传询价单',
        };
    },
    created() {
      this.getRegion()
    },
    methods: {
      control_over () {
        if(localStorage.getItem('uuid')) {
          this.$router.push('/control_over_invoices')
        }else{
           this.$confirm({
              title: '请先登录',
              onOk: () => this.$router.push('/login')
          })
        }
      },
       order () {
        if(localStorage.getItem('uuid')) {
          this.$router.push('/order?id=3')
        }else{
           this.$confirm({
              title: '请先登录',
              onOk: () => this.$router.push('/login')
          })
        }
      },
      shop_cart () {
        if(localStorage.getItem('uuid')) {
          this.$router.push('/shop_cart')
        }else{
           this.$confirm({
              title: '请先登录',
              onOk: () => this.$router.push('/login')
          })
        }
      },
      goods_type () {
        if(localStorage.getItem('uuid')) {
          this.$router.push('/goods_type')
        }else{
           this.$confirm({
              title: '请先登录',
              onOk: () => this.$router.push('/login')
          })
        }
      },
      checkLogin() {
            if (window.localStorage.uuid) {
                return true
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                })
                return false
            }
      },
      async uploadAttachment(e) {
        const file = e.target.files[0]
        if (!file) return
        const id = await this.api.uploadFile(file)
        if (id) {
          this.zhaohuo_obj.attachment = id
          this.attachment = file.name
        }
      },
      // selectProvince(index) {
      //   const item = this.list_provicne[index]
      //   this.form_apply.district.district1 = item.name
      //   this.form_apply.district.district1Id = item.id
      //   this.list_city = item.children
      // },
      // selectCity(index) {
      //   const item = this.list_city[index]
      //   this.form_apply.district.district2 = item.name
      //   this.form_apply.district.district2Id = item.id
      // },
      sheng_Change (e) {
      // this.province = e
      this.list_provicne.forEach((element) => {
        if (element.name === e) {
          this.form_apply.district.district2 = ''
          this.form_apply.district.district2Id = ''
          this.form_apply.district.district1 = element.name
          this.form_apply.district.district1Id = element.id
          this.list_city = element.children
        }
      })
    },
    shi_Change (e) {
      // this.city = e
      this.list_city.forEach((element) => {
        if (element.name === e) {
          this.form_apply.district.district2 = element.name
          this.form_apply.district.district2Id = element.id
        }
      })
    },
      getRegion() {
        this.api.get_all_available()
          .then(res => {
            this.list_provicne = res.data
          })
      },
      submitApply() {
        if (!this.checkLogin()) return
        this.form_apply.userId = window.localStorage.uuid
        if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.form_apply.contactsTel)) {
                this.$message.error('请输入正确电话号码');
                return false;
        }
        this.api.agent_application_post(this.form_apply)
          .then(res => {
            if (res.ok) {
              this.$message.success('提交成功')
              this.form_apply = {
                "companyName": "",
                "companyType": "",
                "contactRemarks": "",
                "contacts": "",
                "contactsTel": "",
                "district": {
                  "district1": "",
                  "district1Id": 0,
                  "district2": "",
                  "district2Id": 0,
                  "districtDetail": ""
                },
                "remarks": "",
                "userId": ""
              }
            } else {
              if (res.ok === false) {
                this.$message.error('请确定所有选项填写完整')
              }
              // this.$message.error(res.message)
            }
          })
      },
        // 提交找货
        create_findGoods() {
          if (!this.checkLogin()) return
            if (this.zhaohuo_obj.company == '' || this.zhaohuo_obj.goodsName == '' || this.zhaohuo_obj.purchaseQuantity == '' || this.zhaohuo_obj.userNum == '') {
                this.$message.error('请完善信息');
                return false;
            }
            if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.zhaohuo_obj.userNum)) {
                this.$message.error('请输入正确电话号码');
                return false;
            }

            const data = {...this.zhaohuo_obj}
            data.purchaseQuantity = data.purchaseQuantity + data.unit
            this.api.create_findGoods(data).then(res => {
                if (res.ok) {
                    this.$message.success('提交成功');
                    this.zhaohuo_obj.company = '';
                    this.zhaohuo_obj.userNum = '';
                    this.zhaohuo_obj.goodsName = '';
                    this.zhaohuo_obj.purchaseQuantity = '';
                    this.zhaohuo_obj.remarks = '';
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 顶部切换
        changSwiperRightBox(e) {
            if (e != 2 || e != 3) {
              this.swiper_right_box_index = e;
            }
        },
    },
};
</script>

<style scoped>
/deep/.ant-select-selection--single{
  height: 30px;
}
/* 附件 */
.attachment {
  margin: 10px 0 0 10px;
  font-size: 12px;
  line-height: 13px;
  color: #666;
}
.dianji:hover {
  color: #318d38;
}
.attachment label {cursor: pointer;}

.right_box1_img + div {border-left: 1px dashed #2b9a34;width: 0;height: 26px;margin:auto;
}
.select-region {
  display: flex;
  width: 176px;
  margin-right: 9px;
}
.select-region > div {
  width: 50%;
}
.btn {
  width: 250px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  background: white;
  color: #2B9A34;
  border: 1px solid #2b9a34;
}
.btn:hover {
  background-color: #2B9A34;
  color: white;
}
.btn-search {
  /* background-image: url(./icon/search.png); */
  background-position: 75px 9px;
  background-repeat: no-repeat;
}
/* .btn-search:hover {background-image: url(./icon/search2.png);} */

.bot {
    width: 250px;
    height: 32px;
    border-radius: 6px;
    margin: 0 auto;
    margin-top: 10px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
}
.left {
    width: 70px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
}
.input1 {
    width: 177px;
    height: 30px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    display: inline-block;
}
.title1s {
    width: 90%;
    margin: 10px 0 0 5%;
    height: 33px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
}
.right_box1_txt1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.right_box1_txt1:hover {
  cursor: pointer;
}
.tubiao{
  min-height: 280px;
  display: flex;
  flex-direction:column;
  justify-content:space-between;
  /* border: 1px solid red; */
}

.right_box1_img:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    transform: translateY(-5px);
    transition: all 1s;
    cursor: pointer;
}

.right_box1_img {
    width: 46px;
    height: 46px;
    background: #ffffff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 11px 1px rgba(161, 150, 150, 0.22);
}

.txtx12 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin-top: 10px;
}

.bangmangzhaohou {
    width: 260px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    margin: 20px auto;
    margin-bottom: 0;
    cursor: pointer;
}

.swiper_right_box_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
    margin-top: 5px;
}

.swiper_right_box_top_jylc_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    margin-top: 10px;
}

.swiper_right_box_top_active {
    background: #fff !important;
    color: #2b9a34;
}

.swiper_right_box_top {
    width: 100%;
    height: 10%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
}

.my_order_box {
    transition: all 0.5s;
}

.my_order_box:hover {
    background: #e9f5ea;
}

.txt200:hover {
    transition: all 1s;
    cursor: pointer;
    color: #2b9a34;
}
</style>



// WEBPACK FOOTER //
// src/public/swiper_right.vue